"use strict";
// from https://github.com/LedgerHQ/xpub-scan/blob/master/src/actions/deriveAddresses.ts
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bech32 = __importStar(require("bech32"));
var bech32m_1 = require("../../bech32m");
var bjs = __importStar(require("bitcoinjs-lib"));
var secp256k1_1 = require("./secp256k1");
var errors_1 = require("@ledgerhq/errors");
var types_1 = require("../types");
var base_1 = __importDefault(require("./base"));
/**
 * Temporarily copied fromBech32 and toBech32 from bitcoinjs-lib master branch (as of 2021-09-02,
 * commit 7b753caad6a5bf13d40ffb6ae28c2b00f7f5f585) so that we can make use of the
 * updated bech32 lib version 2.0.0 that supports bech32m. bitcoinjs-lib version 5.2.0
 * as currently used by wallet-btc uses an older version of bech32 that lacks bech32m support.
 *
 * When a new version of bitcoinjs-lib that supports bech32m is released this function can
 * be removed and calls should be directed to bitcoinjs-lib instead. Our direct dependency
 * on bech32 lib should also be removed.
 *
 * TODO: Replace with bitcoinjs-lib call
 */
/* eslint-disable */
function fromBech32(address) {
    var result;
    var version;
    try {
        result = bech32.decode(address);
    }
    catch (e) { }
    if (result) {
        version = result.words[0];
        if (version !== 0)
            throw new TypeError(address + " uses wrong encoding");
    }
    else {
        result = bech32m_1.bech32m.decode(address);
        version = result.words[0];
        if (version === 0)
            throw new TypeError(address + " uses wrong encoding");
    }
    var data = bech32.fromWords(result.words.slice(1));
    return {
        version: version,
        prefix: result.prefix,
        data: Buffer.from(data)
    };
}
function toBech32(data, version, prefix) {
    var words = bech32.toWords(data);
    words.unshift(version);
    return version === 0
        ? bech32.encode(prefix, words)
        : bech32m_1.bech32m.encode(prefix, words);
}
/* eslint-enable */
// This function expects a valid base58check address or a valid
// bech32/bech32m address.
function toOutputScriptTemporary(validAddress, network) {
    try {
        var decodeBase58 = bjs.address.fromBase58Check(validAddress);
        if (decodeBase58.version === network.pubKeyHash)
            return bjs.payments.p2pkh({ hash: decodeBase58.hash }).output;
        if (decodeBase58.version === network.scriptHash)
            return bjs.payments.p2sh({ hash: decodeBase58.hash }).output;
    }
    catch (e) {
        // It's not a base58 address, so it's a segwit address
    }
    var decodeBech32 = fromBech32(validAddress);
    return bjs.script.compile([
        // OP_0 is encoded as 0x00, but OP_1 through OP_16 are encoded as 0x51 though 0x60, see BIP173
        decodeBech32.version + (decodeBech32.version > 0 ? 0x50 : 0),
        decodeBech32.data,
    ]);
}
var Bitcoin = /** @class */ (function (_super) {
    __extends(Bitcoin, _super);
    function Bitcoin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Bitcoin.prototype.toOutputScript = function (address) {
        // Make sure the address is valid on this network
        // otherwise we can't call toOutputScriptTemporary.
        if (!this.validateAddress(address)) {
            throw new errors_1.InvalidAddress();
        }
        // bitcoinjs-lib/src/address doesn't yet have released support for bech32m,
        // so we'll implement our own version of toOutputScript while waiting.
        // This implementation is highly inspired (stolen) from bitcoinjs-lib's
        // master branch.
        // One major difference is that our function requires an already
        // valid address, whereas to bitcoinjs-lib version doesn't.
        // TODO: Replace with bitcoinjs-lib call
        return toOutputScriptTemporary(address, this.network);
    };
    Bitcoin.prototype.validateAddress = function (address) {
        try {
            // This prefix check is to avoid returning false in cases where a valid base58 address also happens
            // to be a valid bech32(m) string (but invalid segwit address).
            if (address.toLowerCase().startsWith("".concat(this.network.bech32, "1"))) {
                return this.tryBech32(address);
            }
        }
        catch (_a) {
            /* Try base58 instead */
        }
        try {
            return this.tryBase58(address);
        }
        catch (_b) {
            return false;
        }
    };
    // get address given an address type
    Bitcoin.prototype.customGetAddress = function (derivationMode, xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = derivationMode;
                        switch (_a) {
                            case types_1.DerivationModes.TAPROOT: return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getTaprootAddress(xpub, account, index)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3: return [2 /*return*/, _super.prototype.customGetAddress.call(this, derivationMode, xpub, account, index)];
                }
            });
        });
    };
    Bitcoin.prototype.tryBech32 = function (address) {
        var result = fromBech32(address);
        if (this.network.bech32 !== result.prefix) {
            // Address doesn't use the expected human-readable part ${network.bech32}
            return false;
        }
        if (result.version > 16 || result.version < 0) {
            // Address has invalid version
            return false;
        }
        if (result.data.length < 2 || result.data.length > 40) {
            // Address has invalid data length
            return false;
        }
        if (result.version === 0 &&
            result.data.length !== 20 &&
            result.data.length !== 32) {
            // Version 0 address uses an invalid witness program length
            return false;
        }
        return true;
    };
    Bitcoin.prototype.tryBase58 = function (address) {
        var result = bjs.address.fromBase58Check(address);
        if (this.network.pubKeyHash === result.version ||
            this.network.scriptHash === result.version) {
            return true;
        }
        return false;
    };
    Bitcoin.prototype.hashTapTweak = function (x) {
        // hash_tag(x) = SHA256(SHA256(tag) || SHA256(tag) || x), see BIP340
        // See https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki#specification
        var h = bjs.crypto.sha256(Buffer.from("TapTweak", "utf-8"));
        return bjs.crypto.sha256(Buffer.concat([h, h, x]));
    };
    Bitcoin.prototype.getTaprootAddress = function (xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var ecdsaPubkey, schnorrInternalPubkey, evenEcdsaPubkey, tweak, outputEcdsaKey, _a, _b, outputSchnorrKey;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getPubkeyAt(xpub, account, index)];
                    case 1:
                        ecdsaPubkey = _c.sent();
                        schnorrInternalPubkey = ecdsaPubkey.slice(1);
                        evenEcdsaPubkey = Buffer.concat([
                            Buffer.from([0x02]),
                            schnorrInternalPubkey,
                        ]);
                        tweak = this.hashTapTweak(schnorrInternalPubkey);
                        _b = (_a = Buffer).from;
                        return [4 /*yield*/, (0, secp256k1_1.getSecp256k1Instance)().publicKeyTweakAdd(evenEcdsaPubkey, tweak)];
                    case 2:
                        outputEcdsaKey = _b.apply(_a, [_c.sent()]);
                        outputSchnorrKey = outputEcdsaKey.slice(1);
                        // Create address
                        return [2 /*return*/, toBech32(outputSchnorrKey, 1, this.network.bech32)];
                }
            });
        });
    };
    Bitcoin.prototype.isTaprootAddress = function (address) {
        // This prefix check is to avoid returning false in cases where a valid base58 address also happens
        // to be a valid bech32(m) string (but invalid segwit address).
        if (address.toLowerCase().startsWith("".concat(this.network.bech32, "1"))) {
            try {
                bjs.address.fromBech32(address);
            }
            catch (_a) {
                return true;
            }
        }
        return false;
    };
    return Bitcoin;
}(base_1["default"]));
exports["default"] = Bitcoin;
//# sourceMappingURL=bitcoin.js.map